import React from 'react';
import { AnimateOnScroll } from './AnimateOnScroll';
import './Testimonials.css';

const testimonials = [
  {
    name: 'Sophie de Vries',
    role: 'Verloor 12 kg in 4 maanden',
    content: 'De boodschappenlijst functie is geweldig! Ik kan vooraf plannen wat ik ga maken en alle ingredienten toevoegen. De barcode scanner maakt loggen super makkelijk.',
    rating: 5,
    avatar: 'S'
  },
  {
    name: 'Mark Jansen',
    role: 'Fanatiek hardloper',
    content: 'De workout tracker is perfect voor mijn trainingen. Ik kan al mijn hardloopsessies monitoren en zie precies hoeveel calorieën ik verbrand. De buddy functie houdt me gemotiveerd!',
    rating: 5,
    avatar: 'M'
  },
  {
    name: 'Lisa Bakker',
    role: 'Werkende moeder',
    content: 'Met twee kinderen heb ik geen tijd om na te denken over maaltijden. De boodschappenlijst helpt me om vooraf te plannen wat ik ga maken en ik vergeet nooit meer iets in de winkel!',
    rating: 5,
    avatar: 'L'
  }
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="testimonials">
      <div className="testimonials__container">
        <AnimateOnScroll animation="fadeUp">
          <div className="testimonials__header">
            <span className="testimonials__label">Ervaringen</span>
            <h2 className="testimonials__title">Wat onze gebruikers zeggen</h2>
            <p className="testimonials__subtitle">
              Duizenden mensen gebruiken BalanzFit dagelijks om hun fitnessdoelen te bereiken. Hier zijn enkele van hun verhalen.
            </p>
          </div>
        </AnimateOnScroll>
        
        <div className="testimonials__grid">
          {testimonials.map((testimonial, index) => (
            <AnimateOnScroll key={index} animation="fadeUp" delay={index * 0.15}>
              <article className="testimonial-card">
                <div className="testimonial-card__rating">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <svg key={i} className="testimonial-card__star" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 1L12.39 6.36L18.18 7.27L14.09 11.22L15.08 16.99L10 14.27L4.92 16.99L5.91 11.22L1.82 7.27L7.61 6.36L10 1Z"/>
                    </svg>
                  ))}
                </div>
                <p className="testimonial-card__content">"{testimonial.content}"</p>
                <div className="testimonial-card__author">
                  <div className="testimonial-card__avatar">{testimonial.avatar}</div>
                  <div className="testimonial-card__info">
                    <span className="testimonial-card__name">{testimonial.name}</span>
                    <span className="testimonial-card__role">{testimonial.role}</span>
                  </div>
                </div>
              </article>
            </AnimateOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(Testimonials);
